import React from 'react';
import './Services.css'; 
import Image2 from '../images/img-cables-wire.jpg';
import Image3 from '../images/img-dairy-products.jpg';
import Image4 from '../images/img-fmeg-electronics.jpg';
import Image5 from '../images/img-formulations-medical-devise.jpg'
function Services() {
  const servicesData = [
    {
      title: 'Cables & Wire',
      description: 'Industrial application of Cable & wires.',
      image: Image2,
    },
    {
      title: 'Dairy Products',
      description: 'Dairy plays a significant part in numerous aspects.',
      image: Image3,
    },
    {
      title: 'FMEG & Electronics',
      description: 'FMEG is an emerging sector in India`s current market.',
      image: Image4,
    },
    {
      title: 'Pharmaceutical',
      description: 'Pharma formulation having a wide range of application.',
      image: Image5,
    },
  ];


  return (
    <div className="services-section">
      <div className="container">
        <h2 className="services-heading">We Provide All Kinds Of Printing Services or Applications</h2>
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div className="service-card" key={index}>
              <img src={service.image} alt={service.title} className="service-image" />
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
       
      </div>
    </div>
  );
}

export default Services;
